import { modelComposition } from 'trait/composition'

const descriptor = 'model::feedback'

export default modelComposition(descriptor)
